export default __webpack_public_path__ + "static/media/analyst_drawer_worksheet.c831e80b.svg";